import { Request } from '../utils';

const prefix = 'medicine';

// GET  - Products(Medicine) List
export const getProductsList = queries => {
  const { limit, skip, orderBy, sortBy, name, atc_code, atc_name, barcode, statuses } = queries;
  const params = new URLSearchParams();

  params.append('limit', limit);
  params.append('skip', skip);
  !!orderBy && params.append('order_by', orderBy);
  !!sortBy && params.append('sort_by', sortBy);
  !!name && params.append('name', name);
  !!atc_code && params.append('atc_code', atc_code);
  !!atc_name && params.append('atc_name', atc_name);
  !!barcode && params.append('barcode', barcode);
  !!statuses[0] && params.append('statuses[0]', statuses[0]);

  return Request.get(`${prefix}`, { params, onlyError: true });
};

// PUT - Update Medicine Status
export const updateProductStatus = (medicineId, values) => {
  return Request.put(`${prefix}/${medicineId}/status`, values, { handleNotification: true });
};
